import { Dimensions, StyleSheet, useWindowDimensions, View } from 'react-native'
import { DS } from '../../../../../design-system'
import PermissionSettings from '../../../../../assets/PermissionSettings.svg'
import { palette } from '../../../../../theme/palette'
import React from 'react'

export const AVBlocked = ({ blockedPermission }: { blockedPermission: 'camera' | 'microphone' | undefined }) => {
  const { width } = useWindowDimensions()
  const isSmallDevice = width < 370

  if (!blockedPermission) {
    return null
  }

  return (
    <React.Fragment>
      <PermissionSettings style={[styles.image, styles.bigImageSize]} />
      <DS.Frame style={styles.textContainer} gap="32">
        <DS.Text variant="Body Large/Regular" style={{ fontSize: isSmallDevice ? 22 : 24, paddingRight: 32 }}>
          {`Poker Power is blocked from accessing your ${blockedPermission === 'camera' ? 'camera' : 'microphone'}`}
        </DS.Text>
        <DS.Frame gap="16">
          <DS.Frame style={{ flexDirection: 'row' }}>
            <DS.Text variant="Body Large/Regular" style={{ fontSize: 18, marginRight: 8 }}>
              1.
            </DS.Text>
            <DS.Text variant="Body Large/Regular" style={{ fontSize: 18, position: 'relative' }}>
              Navigate to your browser's Settings
            </DS.Text>
          </DS.Frame>

          <DS.Frame style={{ flexDirection: 'row' }}>
            <DS.Text variant="Body Large/Regular" style={{ fontSize: 18, marginRight: 8 }}>
              2.
            </DS.Text>
            <DS.Text variant="Body Large/Regular" style={{ fontSize: 18 }}>
              Clear blocked {blockedPermission === 'camera' ? 'camera' : 'microphone'} permissions
            </DS.Text>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
    </React.Fragment>
  )
}

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.blackWithOpacity.twenty
  },
  container: {
    backgroundColor: palette.cream,
    borderRadius: 12,
    paddingHorizontal: 32,
    paddingVertical: 64,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    maxWidth: 800
  },
  textContainer: {
    flex: 1,
    minWidth: 250
  },
  image: {
    alignSelf: 'center'
  },
  bigImageSize: {
    height: 120,
    width: 120
  },
  smallImageSize: {
    height: 200,
    width: 200
  }
})
